<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="委外发料详情"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="发料单号">
            <el-input v-model="model.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
          <el-form-item label="采购单号">
            <el-input v-model="model.purchaseOrderNos" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="创建人">
            <el-input v-model="model.creatorName" placeholder="系统自动生成" disabled/>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="model.createTime" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            发料明细
          </div>
          <el-table
              :data="mergeMaterialList"
              border
              style="width: 100%"
              show-summary
              :summary-method="getSummary">
            <el-table-column prop="materialNo" align="center" label="物料号" width="90"/>
            <el-table-column prop="materialName" align="center" label="物料描述"/>
            <el-table-column prop="location" align="center" label="库存地址" width="80"/>
            <el-table-column prop="locationSumQty" align="center" label="工厂库存" width="80"/>
            <el-table-column prop="sumQty" align="center" label="发料数量" width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sumQty" placeholder="请输入数量"/>
              </template>
            </el-table-column>
            <el-table-column prop="supplierSumQty" align="center" label="供应商库存" width="85"/>
            <el-table-column prop="billNo1" align="center" :label="billNo1" width="90"/>
            <el-table-column prop="billNo2" align="center" :label="billNo2" width="90"/>
            <el-table-column prop="billNo3" align="center" :label="billNo3" width="90"/>
            <el-table-column prop="billNo4" align="center" :label="billNo4" width="90"/>
            <el-table-column prop="billNo5" align="center" :label="billNo5" width="90"/>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <template>
          <el-button
              type="primary"
              :loading="saveLoading"
              @click="handleSave">保存</el-button>
        </template>
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name: "MergeMaterialEdit",
    components: {},
    data() {
      return {
        uploadAuth: this.$auth(454),
        constant,
        uploadLoading: false,
        userType: LoginUtil.getUserType(),
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        submitLoading: false,
        submitDisable: true,
        tableData: [],
        mergeMaterialList: [],
        receiveStatus: "",
        billNo1: "",
        billNo2: "",
        billNo3: "",
        billNo4: "",
        billNo5: "",
        activeName: "first",
        files: [],
        model: {
          purchaseOrderNos: "",
          billNo: "",
          creatorName: "",
          createTime: "",
          mergeMaterialDetails: [],
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        if (id > 0) {
          this.getData(id);
        }
      },
      getData(id) {
        this.contentLoading = true;
        this.$http.get("basic", `mergeMaterials/${id}`).then((resp) => {
          this.model = resp.data;
          console.log(this.model);
          this.mergeMaterialList = JSON.parse(JSON.stringify(resp.data.mergeMaterialDetails));
          let index = this.model.mergeMaterialDetails.length-1;
          let item = this.model.mergeMaterialDetails[index];
          if (item.billNo1) {
            this.billNo1 = item.billNo1;
          }
          if (item.billNo2) {
            this.billNo2 = item.billNo2;
          }
          if (item.billNo3) {
            this.billNo3 = item.billNo3;
          }
          if (item.billNo4) {
            this.billNo4 = item.billNo4;
          }
          if (item.billNo5) {
            this.billNo5 = item.billNo5;
          }
          this.mergeMaterialList.splice(this.mergeMaterialList.length - 1, 1);
        }).finally(() => {
          this.contentLoading = false;
        });
      },
      handleSave() {
        this.model.mergeMaterialDetails = [];
        this.model.mergeMaterialDetails = JSON.parse(JSON.stringify(this.mergeMaterialList));
        this.model.mergeMaterialDetails.push({
          billNo1: this.billNo1,
          billNo2: this.billNo2,
          billNo3: this.billNo3,
          billNo4: this.billNo4,
          billNo5: this.billNo5,
        });
        this.saveLoading = true;
        this.$http
          .put("basic", "mergeMaterials", this.model)
          .then(() => {
            this.saveLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.saveLoading = false;
          });
      },

      getSummary({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.property === "locationSumQty" || column.property === "sumQty" || column.property === "supplierSumQty") {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },
    },
  };
</script>

<style lang="scss" scoped>
.purchaseOrder {
  .el-form-item__content {
    margin-left: 2% !important;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
    margin-bottom: 15px;
  }

  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
    border-left: 1px solid #EBEEF5;
  }
}

</style>
